<script>
import BaseLidar from '../BaseLidar'

export default {
  name: 'DataDisplayMicrowaveRadiometer',
  routeInfo: {
    label: '微波辐射',
    icon: 'fa fa-users'
  },
  extends: BaseLidar,
  computed: {
    siteDeviceCategory: () => process.env.MICROWAVE_RADIOMETER_DEVICE_CATEGORY
  }
}
</script>



// WEBPACK FOOTER //
// src/views/03Data-Display/98VerticalDetection/03MicrowaveRadiometer/index.vue